module.exports = __webpack_public_path__ + "img/y3-logo.6a507347.png";